'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@chakra-ui/react');
var jsxRuntime = require('@emotion/react/jsx-runtime');
var utils = require('@chakra-ui/utils');
var framerMotion = require('framer-motion');
var designSystemIcons = require('@digital-retail/design-system-icons');
var React = require('react');
var icons = require('@chakra-ui/icons');
var themeTools = require('@chakra-ui/theme-tools');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$i =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$b = fails$d;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$e = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$e.bind(call$e) : function () {
  return call$e.apply(call$e, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$d = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$d, call$d);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$d.apply(fn, arguments);
  };
};

var uncurryThis$f = functionUncurryThis;

var toString$3 = uncurryThis$f({}.toString);
var stringSlice$2 = uncurryThis$f(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$2(toString$3(it), 8, -1);
};

var uncurryThis$e = functionUncurryThis;
var fails$a = fails$d;
var classof$5 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$e(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$c = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (isNullOrUndefined$3(it)) throw $TypeError$c("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$l = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$k = isCallable$l;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$8 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$k(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$k(it);
};

var global$h = global$i;
var isCallable$j = isCallable$l;

var aFunction = function (argument) {
  return isCallable$j(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$h[namespace]) : global$h[namespace] && global$h[namespace][method];
};

var uncurryThis$d = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$d({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$g = global$i;
var userAgent$3 = engineUserAgent;

var process$4 = global$g.process;
var Deno$1 = global$g.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$9 = fails$d;
var global$f = global$i;

var $String$5 = global$f.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$i = isCallable$l;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$i($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$h = isCallable$l;
var tryToString$3 = tryToString$4;

var $TypeError$b = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$8 = function (argument) {
  if (isCallable$h(argument)) return argument;
  throw $TypeError$b(tryToString$3(argument) + ' is not a function');
};

var aCallable$7 = aCallable$8;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable$7(func);
};

var call$c = functionCall;
var isCallable$g = isCallable$l;
var isObject$7 = isObject$8;

var $TypeError$a = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$g(fn = input.toString) && !isObject$7(val = call$c(fn, input))) return val;
  if (isCallable$g(fn = input.valueOf) && !isObject$7(val = call$c(fn, input))) return val;
  if (pref !== 'string' && isCallable$g(fn = input.toString) && !isObject$7(val = call$c(fn, input))) return val;
  throw $TypeError$a("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$e = global$i;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$e, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$e[key] = value;
  } return value;
};

var global$d = global$i;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$d[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var uncurryThis$c = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$c({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$b = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$2 = uncurryThis$b(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$2(++id + postfix, 36);
};

var global$c = global$i;
var shared$2 = shared$3.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$c.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$e = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$a(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$b = functionCall;
var isObject$6 = isObject$8;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$d = wellKnownSymbol$e;

var $TypeError$9 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$d('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$b(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw $TypeError$9("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$b = global$i;
var isObject$5 = isObject$8;

var document$3 = global$b.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$5(document$3) && isObject$5(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$b = descriptors;
var fails$8 = fails$d;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$b && !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$a = descriptors;
var call$a = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$a ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$2(!call$a(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$9 = descriptors;
var fails$7 = fails$d;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$9 && fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$4 = isObject$8;

var $String$3 = String;
var $TypeError$8 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$a = function (argument) {
  if (isObject$4(argument)) return argument;
  throw $TypeError$8($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$9 = anObject$a;
var toPropertyKey = toPropertyKey$2;

var $TypeError$7 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$9(O);
  P = toPropertyKey(P);
  anObject$9(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$7('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$6 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$6 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$6 || (DESCRIPTORS$6 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$a = functionUncurryThis;
var isCallable$f = isCallable$l;
var store$1 = sharedStore;

var functionToString = uncurryThis$a(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$f(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$a = global$i;
var isCallable$e = isCallable$l;

var WeakMap$1 = global$a.WeakMap;

var weakMapBasicDetection = isCallable$e(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$9 = global$i;
var isObject$3 = isObject$8;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$9.TypeError;
var WeakMap = global$9.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$3(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$9 = functionUncurryThis;
var fails$6 = fails$d;
var isCallable$d = isCallable$l;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$5 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$1 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$1 = uncurryThis$9(''.slice);
var replace$1 = uncurryThis$9(''.replace);
var join = uncurryThis$9([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$5 && !fails$6(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$1($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$1($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$5) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$5) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$d(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$c = isCallable$l;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$c(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$8 = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$8([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$7 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$a;

var concat$1 = uncurryThis$7([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$d;
var isCallable$b = isCallable$l;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$b(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$8 = global$i;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$8;
  } else if (STATIC) {
    target = global$8[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$8[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var uncurryThis$6 = functionUncurryThis;
var call$9 = functionCall;
var fails$4 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$6([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$8 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$8({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const Card = react.forwardRef(function Card(props, ref) {
  const _a = react.omitThemingProps(props),
    {
      className,
      children,
      direction = 'column',
      justify,
      align
    } = _a,
    rest = __rest(_a, ["className", "children", "direction", "justify", "align"]);
  const styles = react.useMultiStyleConfig('Card', props);
  return jsxRuntime.jsx(react.chakra.div, Object.assign({
    ref: ref,
    className: utils.cx('chakra-card', className),
    __css: Object.assign({
      display: 'flex',
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      position: 'relative',
      minWidth: 0,
      wordWrap: 'break-word'
    }, styles.container)
  }, rest, {
    children: jsxRuntime.jsx(react.StylesProvider, Object.assign({
      value: styles
    }, {
      children: children
    }))
  }));
});

const CardBody = react.forwardRef((props, ref) => {
  const {
      className
    } = props,
    rest = __rest(props, ["className"]);
  const styles = react.useStyles();
  return jsxRuntime.jsx(react.chakra.div, Object.assign({
    ref: ref,
    className: utils.cx('chakra-card__body', className),
    __css: styles.body
  }, rest));
});

const CardFooter = react.forwardRef((props, ref) => {
  const {
      className,
      justify
    } = props,
    rest = __rest(props, ["className", "justify"]);
  const styles = react.useStyles();
  return jsxRuntime.jsx(react.chakra.div, Object.assign({
    ref: ref,
    className: utils.cx('chakra-card__footer', className),
    __css: Object.assign({
      display: 'flex',
      justifyContent: justify
    }, styles.footer)
  }, rest));
});

const CardHeader = react.forwardRef((props, ref) => {
  const styles = react.useStyles();
  const {
      className
    } = props,
    rest = __rest(props, ["className"]);
  return jsxRuntime.jsx(react.chakra.div, Object.assign({
    ref: ref,
    className: utils.cx('chakra-card__header', className),
    __css: styles.header
  }, rest));
});

function __motion(el) {
  const m = framerMotion.motion;
  if ('custom' in m && typeof m.custom === 'function') {
    return m.custom(el);
  }
  return m(el);
}
// @future: only call `motion(chakra.svg)` when we drop framer-motion v3 support
const MotionSvg = __motion(react.chakra.svg);
const CheckIcon = props => jsxRuntime.jsx(MotionSvg, Object.assign({
  width: "1.2em",
  viewBox: "0 0 20 20",
  variants: {
    unchecked: {
      opacity: 0,
      strokeDashoffset: 16
    },
    checked: {
      opacity: 1,
      strokeDashoffset: 0,
      transition: {
        duration: 0.2
      }
    }
  },
  style: {
    fill: 'none'
  }
}, props, {
  children: jsxRuntime.jsx(designSystemIcons.CheckIcon, {})
}));
const IndeterminateIcon = props => jsxRuntime.jsx(MotionSvg, Object.assign({
  width: "1.2em",
  viewBox: "0 0 20 20",
  variants: {
    unchecked: {
      scaleX: 0.65,
      opacity: 0
    },
    checked: {
      scaleX: 1,
      opacity: 1,
      transition: {
        scaleX: {
          duration: 0
        },
        opacity: {
          duration: 0.02
        }
      }
    }
  },
  style: {
    stroke: 'currentColor',
    strokeWidth: 4
  }
}, props, {
  children: jsxRuntime.jsx("rect", {
    x: "4",
    y: "4",
    width: "12",
    height: "12",
    rx: "2",
    fill: "currentColor"
  })
}));
const CheckboxTransition = ({
  open,
  children
}) => jsxRuntime.jsx(framerMotion.AnimatePresence, Object.assign({
  initial: false
}, {
  children: open && jsxRuntime.jsx(framerMotion.motion.div, Object.assign({
    variants: {
      unchecked: {
        scale: 0.5,
        opacity: 0,
        transition: {
          duration: 0.1
        }
      },
      checked: {
        scale: 1,
        opacity: 1,
        transition: {
          duration: 0.1
        }
      }
    },
    initial: "unchecked",
    animate: "checked",
    exit: "unchecked",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  }, {
    children: children
  }))
}));
/**
 * CheckboxIcon is used to visually indicate the checked or indeterminate
 * state of a checkbox.
 *
 * @todo allow users pass their own icon svgs
 */
const CheckboxIcon = props => {
  const {
      isIndeterminate,
      isChecked
    } = props,
    rest = __rest(props, ["isIndeterminate", "isChecked"]);
  const IconEl = isIndeterminate ? IndeterminateIcon : CheckIcon;
  return jsxRuntime.jsx(CheckboxTransition, Object.assign({
    open: isChecked || isIndeterminate
  }, {
    children: jsxRuntime.jsx(IconEl, Object.assign({}, rest))
  }));
};
const Checkbox = props => {
  return jsxRuntime.jsx(react.Checkbox, Object.assign({
    icon: jsxRuntime.jsx(CheckboxIcon, {})
  }, props));
};

function PaginationItem({
  isCurrent = false,
  page,
  onPageChange,
  colorScheme
}) {
  if (isCurrent) {
    return jsxRuntime.jsx(react.Button, Object.assign({
      variant: "solid",
      colorScheme: colorScheme,
      size: "sm",
      fontSize: "xs",
      width: "4",
      disabled: true,
      _disabled: {
        pointerEvents: 'none'
      }
    }, {
      children: page
    }));
  }
  return jsxRuntime.jsx(react.Button, Object.assign({
    variant: "ghost",
    colorScheme: colorScheme,
    size: "sm",
    fontSize: "xs",
    width: "4",
    bg: "none",
    fontWeight: "bold",
    onClick: () => onPageChange(page)
  }, {
    children: page
  }));
}

function Pagination({
  currentPage,
  lastPage,
  previousPages,
  nextPages,
  siblingsCount,
  onPageChange,
  colorScheme
}) {
  return jsxRuntime.jsx(react.Stack, Object.assign({
    direction: "row",
    justify: "flex-end",
    align: "center",
    spacing: "6"
  }, {
    children: jsxRuntime.jsxs(react.Stack, Object.assign({
      direction: "row",
      spacing: "4"
    }, {
      children: [currentPage > 1 + siblingsCount ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [jsxRuntime.jsx(PaginationItem, {
          colorScheme: colorScheme,
          onPageChange: onPageChange,
          page: 1
        }), currentPage > 2 + siblingsCount ? jsxRuntime.jsx(react.Text, Object.assign({
          color: "gray.300",
          w: "8",
          textAlign: "center",
          fontSize: "md"
        }, {
          children: "..."
        })) : null]
      }) : null, previousPages.length > 0 ? previousPages.map(page => jsxRuntime.jsx(PaginationItem, {
        colorScheme: colorScheme,
        onPageChange: onPageChange,
        page: page
      }, page)) : null, jsxRuntime.jsx(PaginationItem, {
        colorScheme: colorScheme,
        onPageChange: onPageChange,
        page: currentPage,
        isCurrent: true
      }), nextPages.length > 0 ? nextPages.map(page => jsxRuntime.jsx(PaginationItem, {
        colorScheme: colorScheme,
        onPageChange: onPageChange,
        page: page
      }, page)) : null, currentPage + siblingsCount < lastPage ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [currentPage + 1 + siblingsCount < lastPage ? jsxRuntime.jsx(react.Text, Object.assign({
          color: "gray.300",
          w: "8",
          textAlign: "center",
          fontSize: "md"
        }, {
          children: "..."
        })) : null, jsxRuntime.jsx(PaginationItem, {
          colorScheme: colorScheme,
          onPageChange: onPageChange,
          page: lastPage
        })]
      }) : null]
    }))
  }));
}

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$7 = anObject$a;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$7(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$6 = anObject$a;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$6(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$c = wellKnownSymbol$e;
var create$1 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$c('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$3 = fails$d;

var correctPrototypeGetter = !fails$3(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$a = isCallable$l;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$a(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$2 = fails$d;
var isCallable$9 = isCallable$l;
var isObject$2 = isObject$8;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$5;
var wellKnownSymbol$b = wellKnownSymbol$e;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$2(IteratorPrototype$2) || fails$2(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$9(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$a = wellKnownSymbol$e;

var TO_STRING_TAG$3 = wellKnownSymbol$a('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$5 = functionUncurryThis;
var aCallable$6 = aCallable$8;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$5(aCallable$6(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$8 = isCallable$l;

var $String$1 = String;
var $TypeError$6 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$8(argument)) return argument;
  throw $TypeError$6("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$5 = anObject$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$5(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$7 = _export;
var call$8 = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$l;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$2 = defineBuiltIn$5;
var wellKnownSymbol$9 = wellKnownSymbol$e;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$9('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$8(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$7({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$7 = global$i;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$8 = wellKnownSymbol$e;

var ITERATOR$3 = wellKnownSymbol$8('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$7[COLLECTION_NAME] && global$7[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

function generatePagesArray(from, to) {
  return [...new Array(to - from)].map((_, index) => from + index + 1).filter(page => page > 0);
}
function usePagination({
  totalRegisters,
  page,
  items,
  registersPerPage = 10,
  siblingsCount = 1
}) {
  const currentPage = page;
  const lastPage = Math.ceil(totalRegisters / registersPerPage);
  const totalPages = lastPage === 0 ? 1 : lastPage;
  const previousPages = currentPage > 1 ? generatePagesArray(currentPage - 1 - siblingsCount, currentPage - 1) : [];
  const nextPages = currentPage < lastPage ? generatePagesArray(currentPage, Math.min(currentPage + siblingsCount, lastPage)) : [];
  const pageStart = (page - 1) * registersPerPage;
  const pageEnd = pageStart + registersPerPage;
  const pageItems = items === undefined ? undefined : items.slice(pageStart, pageEnd);
  return {
    pageItems,
    currentPage,
    totalPages,
    totalRegisters,
    lastPage,
    nextPages,
    previousPages,
    registersPerPage,
    siblingsCount
  };
}

var wellKnownSymbol$7 = wellKnownSymbol$e;

var TO_STRING_TAG$1 = wellKnownSymbol$7('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$6 = isCallable$l;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$6 = wellKnownSymbol$e;

var TO_STRING_TAG = wellKnownSymbol$6('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && isCallable$6(O.callee) ? 'Arguments' : result;
};

var classof$3 = classof$4;

var $String = String;

var toString$1 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var $$6 = _export;
var DESCRIPTORS$1 = descriptors;
var global$6 = global$i;
var uncurryThis$4 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$5 = isCallable$l;
var isPrototypeOf$2 = objectIsPrototypeOf;
var toString = toString$1;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$6.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$1 && isCallable$5(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf$2(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis$4(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$4(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$4(''.replace);
  var stringSlice = uncurryThis$4(''.slice);

  defineBuiltInAccessor$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$6({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const StepsContext = /*#__PURE__*/React__namespace.createContext({
  activeStep: 0
});
const useStepsContext = () => React__namespace.useContext(StepsContext);
const StepsProvider = ({
  value,
  children
}) => {
  const [widths, setWidths] = React__namespace.useState([]);
  const isError = value.state === 'error';
  const isLoading = value.state === 'loading';
  const isVertical = value.orientation === 'vertical';
  const isLabelVertical = value.orientation !== 'vertical' && value.labelOrientation === 'vertical';
  return jsxRuntime.jsx(StepsContext.Provider, Object.assign({
    value: Object.assign(Object.assign({}, value), {
      widths,
      setWidths,
      isError,
      isLoading,
      isVertical,
      isLabelVertical
    })
  }, {
    children: children
  }));
};

const Connector = /*#__PURE__*/React__namespace.memo(({
  index,
  isCompletedStep,
  children,
  isLastStep,
  hasLabel
}) => {
  const {
    connector,
    stepIconContainer
  } = react.useStyles();
  const {
    isVertical,
    isLabelVertical,
    widths,
    gap
  } = useStepsContext();
  const getMargin = () => {
    if (isVertical) return `calc(${stepIconContainer.width} / 2)`;
    if (!hasLabel) return 2;
    return 0;
  };
  const styles = React__namespace.useMemo(() => {
    const base = {
      ms: getMargin(),
      my: isVertical ? 2 : 0,
      ps: isVertical ? 4 : 0,
      me: isVertical || isLabelVertical ? 0 : 2,
      height: isVertical ? 'auto' : '2px',
      alignSelf: isVertical ? 'stretch' : 'auto',
      borderTopWidth: isLastStep || isVertical ? 0 : '2px',
      borderInlineStartWidth: isLastStep || !isVertical ? 0 : '2px',
      minHeight: isLastStep || !isVertical ? 'auto' : '1.5rem'
    };
    if (isLabelVertical) {
      return Object.assign(Object.assign({}, base), {
        position: 'absolute',
        top: `calc(${stepIconContainer.height} / 2  - ${base.height} / 2)`,
        left: `calc(((${widths === null || widths === void 0 ? void 0 : widths[index]}px + ${stepIconContainer.width}) / 2) + ${gap})`,
        // use index of next step to determine spacing
        right: `calc((${widths === null || widths === void 0 ? void 0 : widths[index + 1]}px - ${stepIconContainer.width}) / -2 + ${gap})`
      });
    }
    return base;
  }, [widths, isLabelVertical, isVertical, stepIconContainer.height, stepIconContainer.width]);
  return jsxRuntime.jsx(react.chakra.div, Object.assign({
    __css: Object.assign(Object.assign({}, styles), connector),
    "data-highlighted": utils.dataAttr(isCompletedStep)
  }, {
    children: isVertical && children
  }));
});

const MotionFlex = framerMotion.motion(react.Flex);
const AnimatedCloseIcon = framerMotion.motion(icons.CloseIcon);
const AnimatedSpan = framerMotion.motion(react.chakra.span);
const animationConfig = {
  transition: {
    duration: 0.25
  },
  exit: {
    scale: 0.5,
    opacity: 0
  },
  initial: {
    scale: 0.5,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1
  }
};
const StepIcon = react.forwardRef((props, ref) => {
  const {
    icon,
    iconLabel,
    label
  } = react.useStyles();
  const {
    isCompletedStep,
    isCurrentStep,
    isError,
    isLoading,
    isKeepError,
    icon: CustomIcon,
    index,
    checkIcon: CustomCheckIcon,
    ignoreCompletedIcon
  } = props;
  const labelStyles = Object.assign({
    fontWeight: 'medium',
    color: themeTools.mode(`gray.900`, `gray.100`)(props),
    textAlign: 'center',
    fontSize: 'md'
  }, label);
  const Icon = React__default["default"].useMemo(() => CustomIcon ? CustomIcon : null, [CustomIcon]);
  const Check = React__default["default"].useMemo(() => CustomCheckIcon ? CustomCheckIcon : icons.CheckIcon, [CustomCheckIcon]);
  return React__default["default"].useMemo(() => {
    if (isCompletedStep) {
      if (isError && isKeepError) {
        return jsxRuntime.jsx(AnimatedCloseIcon, Object.assign({
          color: "white"
        }, animationConfig, {
          style: icon
        }), "icon");
      }
      if (ignoreCompletedIcon) {
        return jsxRuntime.jsx(AnimatedSpan, Object.assign({
          ref: ref,
          style: iconLabel,
          __css: labelStyles,
          color: "white"
        }, animationConfig, {
          children: (index || 0) + 1
        }), "span-icon");
      }
      return jsxRuntime.jsx(MotionFlex, Object.assign({}, animationConfig, {
        children: jsxRuntime.jsx(Check, {
          color: "white",
          style: icon
        })
      }), "check-icon");
    }
    if (isCurrentStep) {
      if (isError) return jsxRuntime.jsx(AnimatedCloseIcon, Object.assign({
        color: "white"
      }, animationConfig, {
        style: icon
      }), "icon");
      if (isLoading) return jsxRuntime.jsx(react.Spinner, {
        width: icon.width,
        height: icon.height
      });
    }
    if (Icon) return jsxRuntime.jsx(MotionFlex, Object.assign({}, animationConfig, {
      children: jsxRuntime.jsx(Icon, {
        style: icon
      })
    }), "step-icon");
    return jsxRuntime.jsx(AnimatedSpan, Object.assign({
      ref: ref,
      "aria-current": isCurrentStep ? 'step' : undefined,
      style: iconLabel,
      __css: labelStyles,
      color: "white"
    }, animationConfig, {
      children: (index || 0) + 1
    }), "label");
  }, [isCompletedStep, isCurrentStep, isError, isLoading, Icon, icon]);
});

const StepLabel = ({
  isCurrentStep,
  opacity,
  label,
  description
}) => {
  const {
    labelContainer,
    label: labelStyles,
    description: descriptionStyles
  } = react.useStyles();
  const {
    isLabelVertical
  } = useStepsContext();
  const shouldRender = !!label || !!description;
  return shouldRender ? jsxRuntime.jsxs(react.chakra.div, Object.assign({
    "aria-current": isCurrentStep ? 'step' : undefined,
    __css: Object.assign({
      textAlign: isLabelVertical ? 'center' : 'left',
      alignItems: isLabelVertical ? 'center' : 'flex-start'
    }, labelContainer)
  }, {
    children: [!!label && jsxRuntime.jsx(react.chakra.span, Object.assign({
      __css: Object.assign({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 1 : 0,
        opacity
      }, labelStyles)
    }, {
      children: label
    })), !!description && jsxRuntime.jsx(react.chakra.span, Object.assign({
      __css: Object.assign({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 2 : 0,
        opacity
      }, descriptionStyles)
    }, {
      children: description
    }))]
  })) : null;
};

const Step = react.forwardRef((props, ref) => {
  const _a = props,
    {
      children,
      description,
      icon,
      state,
      checkIcon,
      index,
      isCompletedStep,
      isCurrentStep,
      isLastStep,
      isKeepError,
      label,
      ignoreCompletedIcon
    } = _a,
    styleProps = __rest(_a, ["children", "description", "icon", "state", "checkIcon", "index", "isCompletedStep", "isCurrentStep", "isLastStep", "isKeepError", "label", "ignoreCompletedIcon"]);
  const {
    isVertical,
    isError,
    isLoading,
    isLabelVertical,
    checkIcon: defaultCheckIcon,
    onClickStep,
    clickable,
    setWidths,
    stepCount,
    activeStep,
    restrictedFordward
  } = useStepsContext();
  const {
    step,
    stepContainer,
    stepIconContainer
  } = react.useStyles();
  const hasVisited = isCurrentStep || isCompletedStep;
  const opacity = hasVisited ? 1 : 0.8;
  const isClickableStep = restrictedFordward ? index < activeStep && clickable : clickable;
  const handleClick = index => {
    if (isClickableStep && onClickStep) {
      onClickStep(index);
    }
  };
  const containerRef = React__namespace.useCallback(node => {
    if (node && setWidths) {
      setWidths(prev => {
        if (prev.length === stepCount) {
          return [node.offsetWidth || 0];
        }
        return [...prev, node.offsetWidth || 0];
      });
    }
  }, [stepIconContainer.width, stepIconContainer.height]);
  return jsxRuntime.jsxs(react.chakra.li, Object.assign({
    ref: ref,
    onClick: () => handleClick(index),
    "aria-disabled": !hasVisited,
    __css: Object.assign({
      opacity,
      flexDir: isVertical ? 'column' : 'row',
      alignItems: isVertical || isLabelVertical ? 'flex-start' : 'center',
      flex: isLastStep && !isVertical ? '0 0 auto' : '1 0 auto',
      justifyContent: isLastStep && !isVertical ? 'flex-end' : 'flex-start',
      _hover: {
        cursor: isClickableStep ? 'pointer' : 'default'
      }
    }, step)
  }, styleProps, {
    children: [jsxRuntime.jsxs(react.chakra.div, Object.assign({
      ref: containerRef,
      __css: Object.assign({
        flexDir: isLabelVertical ? 'column' : 'row'
      }, stepContainer)
    }, {
      children: [jsxRuntime.jsx(react.chakra.div, Object.assign({
        __css: stepIconContainer,
        "aria-current": hasVisited && isKeepError || isCurrentStep ? 'step' : undefined,
        "data-invalid": utils.dataAttr((hasVisited && isKeepError || isCurrentStep) && (isError || state === 'error')),
        "data-highlighted": utils.dataAttr(isCompletedStep),
        "data-clickable": utils.dataAttr(isClickableStep)
      }, {
        children: jsxRuntime.jsx(framerMotion.AnimatePresence, Object.assign({
          exitBeforeEnter: true
        }, {
          children: jsxRuntime.jsx(StepIcon, Object.assign({}, {
            index,
            isError: isError || state === 'error',
            isLoading: isLoading || state === 'loading',
            isCurrentStep,
            isCompletedStep,
            isKeepError,
            ignoreCompletedIcon
          }, {
            icon: icon,
            checkIcon: checkIcon !== null && checkIcon !== void 0 ? checkIcon : defaultCheckIcon
          }))
        }))
      })), jsxRuntime.jsx(StepLabel, Object.assign({
        label: label,
        description: description
      }, {
        isCurrentStep,
        opacity
      }))]
    })), jsxRuntime.jsx(Connector, Object.assign({
      index: index,
      isLastStep: isLastStep,
      hasLabel: !!label || !!description,
      isCompletedStep: isCompletedStep || false
    }, {
      children: jsxRuntime.jsx(react.Collapse, Object.assign({
        style: {
          width: '100%'
        },
        in: isCurrentStep
      }, {
        children: (isCurrentStep || isCompletedStep) && children
      }))
    }))]
  }));
});

var classof$2 = classofRaw$2;

var engineIsNode = typeof process != 'undefined' && classof$2(process) == 'process';

var getBuiltIn$3 = getBuiltIn$7;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$5 = wellKnownSymbol$e;
var DESCRIPTORS = descriptors;

var SPECIES$2 = wellKnownSymbol$5('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES$2]) {
    defineBuiltInAccessor(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$1 = objectIsPrototypeOf;

var $TypeError$5 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw $TypeError$5('Incorrect invocation');
};

var uncurryThis$3 = functionUncurryThis;
var fails$1 = fails$d;
var isCallable$4 = isCallable$l;
var classof$1 = classof$4;
var getBuiltIn$2 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$3(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$1(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$4;

var $TypeError$4 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$4(tryToString$2(argument) + ' is not a constructor');
};

var anObject$4 = anObject$a;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var wellKnownSymbol$4 = wellKnownSymbol$e;

var SPECIES$1 = wellKnownSymbol$4('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$4(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$4(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$7 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$7.bind(apply$1) : function () {
  return call$7.apply(apply$1, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$2 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$2(fn);
};

var uncurryThis$1 = functionUncurryThisClause;
var aCallable$5 = aCallable$8;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$1(uncurryThis$1.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis = functionUncurryThis;

var arraySlice$1 = uncurryThis([].slice);

var $TypeError$3 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw $TypeError$3('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$5 = global$i;
var apply = functionApply;
var bind$3 = functionBindContext;
var isCallable$3 = isCallable$l;
var hasOwn = hasOwnProperty_1;
var fails = fails$d;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$5.setImmediate;
var clear = global$5.clearImmediate;
var process$3 = global$5.process;
var Dispatch = global$5.Dispatch;
var Function$1 = global$5.Function;
var MessageChannel = global$5.MessageChannel;
var String$1 = global$5.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$5.location;
});

var run = function (id) {
  if (hasOwn(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$5.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$3(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$5.addEventListener &&
    isCallable$3(global$5.postMessage) &&
    !global$5.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$5.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$4 = global$i;
var bind$2 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$4.MutationObserver || global$4.WebKitMutationObserver;
var document$2 = global$4.document;
var process$2 = global$4.process;
var Promise$1 = global$4.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$4, 'queueMicrotask');
var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$2(macrotask, global$4);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$3 = global$i;

var promiseNativeConstructor = global$3.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$2 = global$i;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$2 = isCallable$l;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$3 = wellKnownSymbol$e;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$3('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$2(global$2.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$8;

var $TypeError$2 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$2('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$5 = _export;
var IS_NODE = engineIsNode;
var global$1 = global$i;
var call$6 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$5;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable$3 = aCallable$8;
var isCallable$1 = isCallable$l;
var isObject$1 = isObject$8;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$1.TypeError;
var document$1 = global$1.document;
var process$1 = global$1.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$1(it) && isCallable$1(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$6(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$6(task, global$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$6(task, global$1, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$6(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$3(executor);
    call$6(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$1(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process$1.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$1(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$6(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$5({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$2 = wellKnownSymbol$e;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$2('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof = classof$4;
var getMethod$1 = getMethod$3;
var isNullOrUndefined = isNullOrUndefined$4;
var Iterators = iterators;
var wellKnownSymbol$1 = wellKnownSymbol$e;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof(it)];
};

var call$5 = functionCall;
var aCallable$2 = aCallable$8;
var anObject$3 = anObject$a;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$1 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$3(call$5(iteratorMethod, argument));
  throw $TypeError$1(tryToString$1(argument) + ' is not iterable');
};

var call$4 = functionCall;
var anObject$2 = anObject$a;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$2(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$4(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$2(innerResult);
  return value;
};

var bind = functionBindContext;
var call$3 = functionCall;
var anObject$1 = anObject$a;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$2;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$1(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$3(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol = wellKnownSymbol$e;

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$4 = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$8;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$4({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$2($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$3 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable = isCallable$l;
var defineBuiltIn = defineBuiltIn$5;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$3({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$2 = _export;
var call$1 = functionCall;
var aCallable = aCallable$8;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$2({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$1 = _export;
var call = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$1({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject = anObject$a;
var isObject = isObject$8;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $ = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

const Steps = react.forwardRef((props, ref) => {
  const styles = react.useMultiStyleConfig('Steps', props);
  const stepsStyles = Object.assign({}, styles.steps);
  const _a = react.omitThemingProps(props),
    {
      className,
      activeStep,
      children,
      orientation: orientationProp,
      state,
      responsive,
      checkIcon,
      onClickStep,
      labelOrientation,
      restrictedFordward,
      gap
    } = _a,
    rest = __rest(_a, ["className", "activeStep", "children", "orientation", "state", "responsive", "checkIcon", "onClickStep", "labelOrientation", "restrictedFordward", "gap"]);
  const childArr = React__namespace.Children.toArray(children);
  const stepCount = childArr.length;
  const renderHorizontalContent = () => {
    if (activeStep <= childArr.length) {
      return React__namespace.Children.map(childArr[activeStep], node => {
        if (! /*#__PURE__*/React__namespace.isValidElement(node)) return;
        return React__namespace.Children.map(node.props.children, childNode => childNode);
      });
    }
    return null;
  };
  const clickable = !!onClickStep;
  const [isMobile] = react.useMediaQuery('(max-width: 43em)');
  const orientation = isMobile && responsive ? 'vertical' : orientationProp;
  return jsxRuntime.jsx(react.StylesProvider, Object.assign({
    value: styles
  }, {
    children: jsxRuntime.jsxs(StepsProvider, Object.assign({
      value: {
        activeStep,
        orientation,
        state,
        responsive,
        checkIcon,
        onClickStep,
        labelOrientation,
        clickable,
        colorScheme: props.colorScheme,
        stepCount,
        restrictedFordward,
        gap
      }
    }, {
      children: [jsxRuntime.jsx(react.chakra.ol, Object.assign({
        ref: ref,
        __css: Object.assign({
          justifyContent: stepCount === 1 ? 'flex-end' : 'space-between',
          flexDir: orientation === 'vertical' ? 'column' : 'row'
        }, stepsStyles),
        className: utils.cx('chakra-steps', className)
      }, rest, {
        children: React__namespace.Children.map(children, (child, i) => {
          var _a;
          const isCompletedStep = (_a = /*#__PURE__*/React__namespace.isValidElement(child) && child.props.isCompletedStep) !== null && _a !== void 0 ? _a : i < activeStep;
          const isLastStep = i === stepCount - 1;
          const isCurrentStep = i === activeStep;
          const stepProps = {
            index: i,
            isCompletedStep,
            isCurrentStep,
            isLastStep
          };
          if ( /*#__PURE__*/React__namespace.isValidElement(child)) {
            return /*#__PURE__*/React__namespace.cloneElement(child, stepProps);
          }
          return null;
        })
      })), orientation === 'horizontal' && renderHorizontalContent()]
    }))
  }));
});
Steps.defaultProps = {
  activeStep: 0,
  colorScheme: 'brand',
  orientation: 'horizontal',
  responsive: true
};

function useSteps({
  initialStep
}) {
  const [activeStep, setActiveStep] = React__namespace.useState(initialStep);
  const nextStep = () => {
    setActiveStep(prev => prev + 1);
  };
  const prevStep = () => {
    setActiveStep(prev => prev - 1);
  };
  const reset = () => {
    setActiveStep(initialStep);
  };
  const setStep = step => {
    setActiveStep(step);
  };
  return {
    nextStep,
    prevStep,
    reset,
    setStep,
    activeStep
  };
}

const Toast = props => {
  const {
    action,
    id,
    title,
    isClosable,
    onClose,
    description,
    icon: ToastIcon
  } = props;
  const alertTitleId = typeof id !== 'undefined' ? `toast-${id}-title` : undefined;
  return jsxRuntime.jsxs(react.Alert, Object.assign({
    id: id,
    bg: "gray.800",
    color: "white",
    alignItems: "start",
    borderRadius: "md",
    boxShadow: "lg",
    px: "12px",
    py: "10px",
    textAlign: "start",
    width: "auto",
    "aria-labelledby": alertTitleId
  }, {
    children: [jsxRuntime.jsxs(react.HStack, Object.assign({
      spacing: "12px",
      w: "100%"
    }, {
      children: [ToastIcon && jsxRuntime.jsx(ToastIcon, {
        boxSize: '16px',
        color: "white"
      }), jsxRuntime.jsxs(react.chakra.div, Object.assign({
        flex: "1",
        maxWidth: "100%"
      }, {
        children: [title && jsxRuntime.jsx(react.AlertTitle, Object.assign({
          id: alertTitleId,
          fontSize: "xxs",
          fontWeight: "bold",
          lineHeight: "16px"
        }, {
          children: title
        })), description && jsxRuntime.jsx(react.AlertDescription, Object.assign({
          fontSize: "xxs",
          lineHeight: "16px",
          display: "block",
          as: react.Text,
          noOfLines: title ? 1 : 2
        }, {
          children: description
        }))]
      })), action && jsxRuntime.jsx(react.Button, Object.assign({
        variant: "link",
        size: "xs",
        fontSize: "13px",
        color: "#FFD258",
        _active: {
          color: '#FFD258'
        },
        onClick: action.onClick
      }, {
        children: action.title
      }))]
    })), isClosable && jsxRuntime.jsx(react.CloseButton, {
      size: "sm",
      onClick: onClose,
      position: "absolute",
      insetEnd: 0.5,
      top: 0.5
    })]
  }));
};

const useToast = options => {
  const maxWidth = react.useBreakpointValue({
    base: '320px',
    lg: '630px'
  });
  const toast = react.useToast(options);
  return React__default["default"].useMemo(() => {
    const show = props => {
      return toast(Object.assign(Object.assign({
        containerStyle: props.render ? {} : {
          minWidth: 'auto',
          maxWidth,
          marginBottom: '16px'
        },
        isClosable: false,
        render: rp => jsxRuntime.jsx(Toast, Object.assign({}, props, rp))
      }, options), props));
    };
    show.isActive = toast.isActive;
    show.close = toast.close;
    show.closeAll = toast.closeAll;
    show.update = (id, options) => toast.update(id, Object.assign({
      render: rp => jsxRuntime.jsx(Toast, Object.assign({}, options, rp))
    }, options));
    return show;
  }, [maxWidth, options, toast]);
};

Object.defineProperty(exports, 'AbsoluteCenter', {
	enumerable: true,
	get: function () { return react.AbsoluteCenter; }
});
Object.defineProperty(exports, 'Accordion', {
	enumerable: true,
	get: function () { return react.Accordion; }
});
Object.defineProperty(exports, 'AccordionButton', {
	enumerable: true,
	get: function () { return react.AccordionButton; }
});
Object.defineProperty(exports, 'AccordionDescendantsProvider', {
	enumerable: true,
	get: function () { return react.AccordionDescendantsProvider; }
});
Object.defineProperty(exports, 'AccordionIcon', {
	enumerable: true,
	get: function () { return react.AccordionIcon; }
});
Object.defineProperty(exports, 'AccordionItem', {
	enumerable: true,
	get: function () { return react.AccordionItem; }
});
Object.defineProperty(exports, 'AccordionPanel', {
	enumerable: true,
	get: function () { return react.AccordionPanel; }
});
Object.defineProperty(exports, 'AccordionProvider', {
	enumerable: true,
	get: function () { return react.AccordionProvider; }
});
Object.defineProperty(exports, 'AlertDialog', {
	enumerable: true,
	get: function () { return react.AlertDialog; }
});
Object.defineProperty(exports, 'AlertDialogBody', {
	enumerable: true,
	get: function () { return react.AlertDialogBody; }
});
Object.defineProperty(exports, 'AlertDialogCloseButton', {
	enumerable: true,
	get: function () { return react.AlertDialogCloseButton; }
});
Object.defineProperty(exports, 'AlertDialogContent', {
	enumerable: true,
	get: function () { return react.AlertDialogContent; }
});
Object.defineProperty(exports, 'AlertDialogFooter', {
	enumerable: true,
	get: function () { return react.AlertDialogFooter; }
});
Object.defineProperty(exports, 'AlertDialogHeader', {
	enumerable: true,
	get: function () { return react.AlertDialogHeader; }
});
Object.defineProperty(exports, 'AlertDialogOverlay', {
	enumerable: true,
	get: function () { return react.AlertDialogOverlay; }
});
Object.defineProperty(exports, 'AspectRatio', {
	enumerable: true,
	get: function () { return react.AspectRatio; }
});
Object.defineProperty(exports, 'Badge', {
	enumerable: true,
	get: function () { return react.Badge; }
});
Object.defineProperty(exports, 'Box', {
	enumerable: true,
	get: function () { return react.Box; }
});
Object.defineProperty(exports, 'Button', {
	enumerable: true,
	get: function () { return react.Button; }
});
Object.defineProperty(exports, 'ButtonGroup', {
	enumerable: true,
	get: function () { return react.ButtonGroup; }
});
Object.defineProperty(exports, 'ButtonSpinner', {
	enumerable: true,
	get: function () { return react.ButtonSpinner; }
});
Object.defineProperty(exports, 'Center', {
	enumerable: true,
	get: function () { return react.Center; }
});
Object.defineProperty(exports, 'CheckboxGroup', {
	enumerable: true,
	get: function () { return react.CheckboxGroup; }
});
Object.defineProperty(exports, 'Circle', {
	enumerable: true,
	get: function () { return react.Circle; }
});
Object.defineProperty(exports, 'CircularProgress', {
	enumerable: true,
	get: function () { return react.CircularProgress; }
});
Object.defineProperty(exports, 'CircularProgressLabel', {
	enumerable: true,
	get: function () { return react.CircularProgressLabel; }
});
Object.defineProperty(exports, 'CloseButton', {
	enumerable: true,
	get: function () { return react.CloseButton; }
});
Object.defineProperty(exports, 'Code', {
	enumerable: true,
	get: function () { return react.Code; }
});
Object.defineProperty(exports, 'Collapse', {
	enumerable: true,
	get: function () { return react.Collapse; }
});
Object.defineProperty(exports, 'Container', {
	enumerable: true,
	get: function () { return react.Container; }
});
Object.defineProperty(exports, 'Divider', {
	enumerable: true,
	get: function () { return react.Divider; }
});
Object.defineProperty(exports, 'Drawer', {
	enumerable: true,
	get: function () { return react.Drawer; }
});
Object.defineProperty(exports, 'DrawerBody', {
	enumerable: true,
	get: function () { return react.DrawerBody; }
});
Object.defineProperty(exports, 'DrawerCloseButton', {
	enumerable: true,
	get: function () { return react.DrawerCloseButton; }
});
Object.defineProperty(exports, 'DrawerContent', {
	enumerable: true,
	get: function () { return react.DrawerContent; }
});
Object.defineProperty(exports, 'DrawerFooter', {
	enumerable: true,
	get: function () { return react.DrawerFooter; }
});
Object.defineProperty(exports, 'DrawerHeader', {
	enumerable: true,
	get: function () { return react.DrawerHeader; }
});
Object.defineProperty(exports, 'DrawerOverlay', {
	enumerable: true,
	get: function () { return react.DrawerOverlay; }
});
Object.defineProperty(exports, 'EASINGS', {
	enumerable: true,
	get: function () { return react.EASINGS; }
});
Object.defineProperty(exports, 'Fade', {
	enumerable: true,
	get: function () { return react.Fade; }
});
Object.defineProperty(exports, 'Flex', {
	enumerable: true,
	get: function () { return react.Flex; }
});
Object.defineProperty(exports, 'Grid', {
	enumerable: true,
	get: function () { return react.Grid; }
});
Object.defineProperty(exports, 'GridItem', {
	enumerable: true,
	get: function () { return react.GridItem; }
});
Object.defineProperty(exports, 'HStack', {
	enumerable: true,
	get: function () { return react.HStack; }
});
Object.defineProperty(exports, 'Heading', {
	enumerable: true,
	get: function () { return react.Heading; }
});
Object.defineProperty(exports, 'Hide', {
	enumerable: true,
	get: function () { return react.Hide; }
});
Object.defineProperty(exports, 'Icon', {
	enumerable: true,
	get: function () { return react.Icon; }
});
Object.defineProperty(exports, 'IconButton', {
	enumerable: true,
	get: function () { return react.IconButton; }
});
Object.defineProperty(exports, 'IdProvider', {
	enumerable: true,
	get: function () { return react.IdProvider; }
});
Object.defineProperty(exports, 'Image', {
	enumerable: true,
	get: function () { return react.Image; }
});
Object.defineProperty(exports, 'Img', {
	enumerable: true,
	get: function () { return react.Img; }
});
Object.defineProperty(exports, 'Input', {
	enumerable: true,
	get: function () { return react.Input; }
});
Object.defineProperty(exports, 'InputAddon', {
	enumerable: true,
	get: function () { return react.InputAddon; }
});
Object.defineProperty(exports, 'InputGroup', {
	enumerable: true,
	get: function () { return react.InputGroup; }
});
Object.defineProperty(exports, 'InputLeftAddon', {
	enumerable: true,
	get: function () { return react.InputLeftAddon; }
});
Object.defineProperty(exports, 'InputLeftElement', {
	enumerable: true,
	get: function () { return react.InputLeftElement; }
});
Object.defineProperty(exports, 'InputRightAddon', {
	enumerable: true,
	get: function () { return react.InputRightAddon; }
});
Object.defineProperty(exports, 'InputRightElement', {
	enumerable: true,
	get: function () { return react.InputRightElement; }
});
Object.defineProperty(exports, 'Kbd', {
	enumerable: true,
	get: function () { return react.Kbd; }
});
Object.defineProperty(exports, 'Link', {
	enumerable: true,
	get: function () { return react.Link; }
});
Object.defineProperty(exports, 'LinkBox', {
	enumerable: true,
	get: function () { return react.LinkBox; }
});
Object.defineProperty(exports, 'LinkOverlay', {
	enumerable: true,
	get: function () { return react.LinkOverlay; }
});
Object.defineProperty(exports, 'List', {
	enumerable: true,
	get: function () { return react.List; }
});
Object.defineProperty(exports, 'ListIcon', {
	enumerable: true,
	get: function () { return react.ListIcon; }
});
Object.defineProperty(exports, 'ListItem', {
	enumerable: true,
	get: function () { return react.ListItem; }
});
Object.defineProperty(exports, 'Menu', {
	enumerable: true,
	get: function () { return react.Menu; }
});
Object.defineProperty(exports, 'MenuButton', {
	enumerable: true,
	get: function () { return react.MenuButton; }
});
Object.defineProperty(exports, 'MenuCommand', {
	enumerable: true,
	get: function () { return react.MenuCommand; }
});
Object.defineProperty(exports, 'MenuDescendantsProvider', {
	enumerable: true,
	get: function () { return react.MenuDescendantsProvider; }
});
Object.defineProperty(exports, 'MenuDivider', {
	enumerable: true,
	get: function () { return react.MenuDivider; }
});
Object.defineProperty(exports, 'MenuGroup', {
	enumerable: true,
	get: function () { return react.MenuGroup; }
});
Object.defineProperty(exports, 'MenuIcon', {
	enumerable: true,
	get: function () { return react.MenuIcon; }
});
Object.defineProperty(exports, 'MenuItem', {
	enumerable: true,
	get: function () { return react.MenuItem; }
});
Object.defineProperty(exports, 'MenuItemOption', {
	enumerable: true,
	get: function () { return react.MenuItemOption; }
});
Object.defineProperty(exports, 'MenuList', {
	enumerable: true,
	get: function () { return react.MenuList; }
});
Object.defineProperty(exports, 'MenuOptionGroup', {
	enumerable: true,
	get: function () { return react.MenuOptionGroup; }
});
Object.defineProperty(exports, 'MenuProvider', {
	enumerable: true,
	get: function () { return react.MenuProvider; }
});
Object.defineProperty(exports, 'Modal', {
	enumerable: true,
	get: function () { return react.Modal; }
});
Object.defineProperty(exports, 'ModalBody', {
	enumerable: true,
	get: function () { return react.ModalBody; }
});
Object.defineProperty(exports, 'ModalCloseButton', {
	enumerable: true,
	get: function () { return react.ModalCloseButton; }
});
Object.defineProperty(exports, 'ModalContent', {
	enumerable: true,
	get: function () { return react.ModalContent; }
});
Object.defineProperty(exports, 'ModalContextProvider', {
	enumerable: true,
	get: function () { return react.ModalContextProvider; }
});
Object.defineProperty(exports, 'ModalFocusScope', {
	enumerable: true,
	get: function () { return react.ModalFocusScope; }
});
Object.defineProperty(exports, 'ModalFooter', {
	enumerable: true,
	get: function () { return react.ModalFooter; }
});
Object.defineProperty(exports, 'ModalHeader', {
	enumerable: true,
	get: function () { return react.ModalHeader; }
});
Object.defineProperty(exports, 'ModalOverlay', {
	enumerable: true,
	get: function () { return react.ModalOverlay; }
});
Object.defineProperty(exports, 'OrderedList', {
	enumerable: true,
	get: function () { return react.OrderedList; }
});
Object.defineProperty(exports, 'Popover', {
	enumerable: true,
	get: function () { return react.Popover; }
});
Object.defineProperty(exports, 'PopoverAnchor', {
	enumerable: true,
	get: function () { return react.PopoverAnchor; }
});
Object.defineProperty(exports, 'PopoverArrow', {
	enumerable: true,
	get: function () { return react.PopoverArrow; }
});
Object.defineProperty(exports, 'PopoverBody', {
	enumerable: true,
	get: function () { return react.PopoverBody; }
});
Object.defineProperty(exports, 'PopoverCloseButton', {
	enumerable: true,
	get: function () { return react.PopoverCloseButton; }
});
Object.defineProperty(exports, 'PopoverContent', {
	enumerable: true,
	get: function () { return react.PopoverContent; }
});
Object.defineProperty(exports, 'PopoverFooter', {
	enumerable: true,
	get: function () { return react.PopoverFooter; }
});
Object.defineProperty(exports, 'PopoverHeader', {
	enumerable: true,
	get: function () { return react.PopoverHeader; }
});
Object.defineProperty(exports, 'PopoverTrigger', {
	enumerable: true,
	get: function () { return react.PopoverTrigger; }
});
Object.defineProperty(exports, 'Portal', {
	enumerable: true,
	get: function () { return react.Portal; }
});
Object.defineProperty(exports, 'PortalManager', {
	enumerable: true,
	get: function () { return react.PortalManager; }
});
Object.defineProperty(exports, 'Progress', {
	enumerable: true,
	get: function () { return react.Progress; }
});
Object.defineProperty(exports, 'ProgressLabel', {
	enumerable: true,
	get: function () { return react.ProgressLabel; }
});
Object.defineProperty(exports, 'Radio', {
	enumerable: true,
	get: function () { return react.Radio; }
});
Object.defineProperty(exports, 'RadioGroup', {
	enumerable: true,
	get: function () { return react.RadioGroup; }
});
Object.defineProperty(exports, 'RangeSlider', {
	enumerable: true,
	get: function () { return react.RangeSlider; }
});
Object.defineProperty(exports, 'RangeSliderFilledTrack', {
	enumerable: true,
	get: function () { return react.RangeSliderFilledTrack; }
});
Object.defineProperty(exports, 'RangeSliderMark', {
	enumerable: true,
	get: function () { return react.RangeSliderMark; }
});
Object.defineProperty(exports, 'RangeSliderProvider', {
	enumerable: true,
	get: function () { return react.RangeSliderProvider; }
});
Object.defineProperty(exports, 'RangeSliderThumb', {
	enumerable: true,
	get: function () { return react.RangeSliderThumb; }
});
Object.defineProperty(exports, 'RangeSliderTrack', {
	enumerable: true,
	get: function () { return react.RangeSliderTrack; }
});
Object.defineProperty(exports, 'ScaleFade', {
	enumerable: true,
	get: function () { return react.ScaleFade; }
});
Object.defineProperty(exports, 'Show', {
	enumerable: true,
	get: function () { return react.Show; }
});
Object.defineProperty(exports, 'SimpleGrid', {
	enumerable: true,
	get: function () { return react.SimpleGrid; }
});
Object.defineProperty(exports, 'Skeleton', {
	enumerable: true,
	get: function () { return react.Skeleton; }
});
Object.defineProperty(exports, 'SkeletonCircle', {
	enumerable: true,
	get: function () { return react.SkeletonCircle; }
});
Object.defineProperty(exports, 'SkeletonText', {
	enumerable: true,
	get: function () { return react.SkeletonText; }
});
Object.defineProperty(exports, 'Slide', {
	enumerable: true,
	get: function () { return react.Slide; }
});
Object.defineProperty(exports, 'SlideFade', {
	enumerable: true,
	get: function () { return react.SlideFade; }
});
Object.defineProperty(exports, 'Slider', {
	enumerable: true,
	get: function () { return react.Slider; }
});
Object.defineProperty(exports, 'SliderFilledTrack', {
	enumerable: true,
	get: function () { return react.SliderFilledTrack; }
});
Object.defineProperty(exports, 'SliderMark', {
	enumerable: true,
	get: function () { return react.SliderMark; }
});
Object.defineProperty(exports, 'SliderProvider', {
	enumerable: true,
	get: function () { return react.SliderProvider; }
});
Object.defineProperty(exports, 'SliderThumb', {
	enumerable: true,
	get: function () { return react.SliderThumb; }
});
Object.defineProperty(exports, 'SliderTrack', {
	enumerable: true,
	get: function () { return react.SliderTrack; }
});
Object.defineProperty(exports, 'Spacer', {
	enumerable: true,
	get: function () { return react.Spacer; }
});
Object.defineProperty(exports, 'Spinner', {
	enumerable: true,
	get: function () { return react.Spinner; }
});
Object.defineProperty(exports, 'Square', {
	enumerable: true,
	get: function () { return react.Square; }
});
Object.defineProperty(exports, 'Stack', {
	enumerable: true,
	get: function () { return react.Stack; }
});
Object.defineProperty(exports, 'StackDivider', {
	enumerable: true,
	get: function () { return react.StackDivider; }
});
Object.defineProperty(exports, 'StackItem', {
	enumerable: true,
	get: function () { return react.StackItem; }
});
Object.defineProperty(exports, 'Switch', {
	enumerable: true,
	get: function () { return react.Switch; }
});
Object.defineProperty(exports, 'Text', {
	enumerable: true,
	get: function () { return react.Text; }
});
Object.defineProperty(exports, 'ThemeProvider', {
	enumerable: true,
	get: function () { return react.ChakraProvider; }
});
Object.defineProperty(exports, 'Tooltip', {
	enumerable: true,
	get: function () { return react.Tooltip; }
});
Object.defineProperty(exports, 'UnorderedList', {
	enumerable: true,
	get: function () { return react.UnorderedList; }
});
Object.defineProperty(exports, 'VStack', {
	enumerable: true,
	get: function () { return react.VStack; }
});
Object.defineProperty(exports, 'VisuallyHidden', {
	enumerable: true,
	get: function () { return react.VisuallyHidden; }
});
Object.defineProperty(exports, 'VisuallyHiddenInput', {
	enumerable: true,
	get: function () { return react.VisuallyHiddenInput; }
});
Object.defineProperty(exports, 'Wrap', {
	enumerable: true,
	get: function () { return react.Wrap; }
});
Object.defineProperty(exports, 'WrapItem', {
	enumerable: true,
	get: function () { return react.WrapItem; }
});
Object.defineProperty(exports, 'assignRef', {
	enumerable: true,
	get: function () { return react.assignRef; }
});
Object.defineProperty(exports, 'chakra', {
	enumerable: true,
	get: function () { return react.chakra; }
});
Object.defineProperty(exports, 'createIcon', {
	enumerable: true,
	get: function () { return react.createIcon; }
});
Object.defineProperty(exports, 'createStandaloneToast', {
	enumerable: true,
	get: function () { return react.createStandaloneToast; }
});
Object.defineProperty(exports, 'defaultStandaloneParam', {
	enumerable: true,
	get: function () { return react.defaultStandaloneParam; }
});
Object.defineProperty(exports, 'extendTheme', {
	enumerable: true,
	get: function () { return react.extendTheme; }
});
Object.defineProperty(exports, 'fadeConfig', {
	enumerable: true,
	get: function () { return react.fadeConfig; }
});
Object.defineProperty(exports, 'scaleFadeConfig', {
	enumerable: true,
	get: function () { return react.scaleFadeConfig; }
});
Object.defineProperty(exports, 'slideFadeConfig', {
	enumerable: true,
	get: function () { return react.slideFadeConfig; }
});
Object.defineProperty(exports, 'toast', {
	enumerable: true,
	get: function () { return react.toast; }
});
Object.defineProperty(exports, 'useAccordion', {
	enumerable: true,
	get: function () { return react.useAccordion; }
});
Object.defineProperty(exports, 'useAccordionContext', {
	enumerable: true,
	get: function () { return react.useAccordionContext; }
});
Object.defineProperty(exports, 'useAccordionDescendant', {
	enumerable: true,
	get: function () { return react.useAccordionDescendant; }
});
Object.defineProperty(exports, 'useAccordionDescendants', {
	enumerable: true,
	get: function () { return react.useAccordionDescendants; }
});
Object.defineProperty(exports, 'useAccordionDescendantsContext', {
	enumerable: true,
	get: function () { return react.useAccordionDescendantsContext; }
});
Object.defineProperty(exports, 'useAccordionItem', {
	enumerable: true,
	get: function () { return react.useAccordionItem; }
});
Object.defineProperty(exports, 'useAccordionItemState', {
	enumerable: true,
	get: function () { return react.useAccordionItemState; }
});
Object.defineProperty(exports, 'useAnimationState', {
	enumerable: true,
	get: function () { return react.useAnimationState; }
});
Object.defineProperty(exports, 'useAriaHidden', {
	enumerable: true,
	get: function () { return react.useAriaHidden; }
});
Object.defineProperty(exports, 'useBoolean', {
	enumerable: true,
	get: function () { return react.useBoolean; }
});
Object.defineProperty(exports, 'useBreakpoint', {
	enumerable: true,
	get: function () { return react.useBreakpoint; }
});
Object.defineProperty(exports, 'useBreakpointValue', {
	enumerable: true,
	get: function () { return react.useBreakpointValue; }
});
Object.defineProperty(exports, 'useButtonGroup', {
	enumerable: true,
	get: function () { return react.useButtonGroup; }
});
Object.defineProperty(exports, 'useCallbackRef', {
	enumerable: true,
	get: function () { return react.useCallbackRef; }
});
Object.defineProperty(exports, 'useCheckbox', {
	enumerable: true,
	get: function () { return react.useCheckbox; }
});
Object.defineProperty(exports, 'useCheckboxGroup', {
	enumerable: true,
	get: function () { return react.useCheckboxGroup; }
});
Object.defineProperty(exports, 'useCheckboxGroupContext', {
	enumerable: true,
	get: function () { return react.useCheckboxGroupContext; }
});
Object.defineProperty(exports, 'useClipboard', {
	enumerable: true,
	get: function () { return react.useClipboard; }
});
Object.defineProperty(exports, 'useColorModePreference', {
	enumerable: true,
	get: function () { return react.useColorModePreference; }
});
Object.defineProperty(exports, 'useConst', {
	enumerable: true,
	get: function () { return react.useConst; }
});
Object.defineProperty(exports, 'useControllableProp', {
	enumerable: true,
	get: function () { return react.useControllableProp; }
});
Object.defineProperty(exports, 'useControllableState', {
	enumerable: true,
	get: function () { return react.useControllableState; }
});
Object.defineProperty(exports, 'useDimensions', {
	enumerable: true,
	get: function () { return react.useDimensions; }
});
Object.defineProperty(exports, 'useDisclosure', {
	enumerable: true,
	get: function () { return react.useDisclosure; }
});
Object.defineProperty(exports, 'useEventListener', {
	enumerable: true,
	get: function () { return react.useEventListener; }
});
Object.defineProperty(exports, 'useEventListenerMap', {
	enumerable: true,
	get: function () { return react.useEventListenerMap; }
});
Object.defineProperty(exports, 'useFocusEffect', {
	enumerable: true,
	get: function () { return react.useFocusEffect; }
});
Object.defineProperty(exports, 'useFocusOnHide', {
	enumerable: true,
	get: function () { return react.useFocusOnHide; }
});
Object.defineProperty(exports, 'useFocusOnPointerDown', {
	enumerable: true,
	get: function () { return react.useFocusOnPointerDown; }
});
Object.defineProperty(exports, 'useFocusOnShow', {
	enumerable: true,
	get: function () { return react.useFocusOnShow; }
});
Object.defineProperty(exports, 'useForceUpdate', {
	enumerable: true,
	get: function () { return react.useForceUpdate; }
});
Object.defineProperty(exports, 'useId', {
	enumerable: true,
	get: function () { return react.useId; }
});
Object.defineProperty(exports, 'useIds', {
	enumerable: true,
	get: function () { return react.useIds; }
});
Object.defineProperty(exports, 'useImage', {
	enumerable: true,
	get: function () { return react.useImage; }
});
Object.defineProperty(exports, 'useInterval', {
	enumerable: true,
	get: function () { return react.useInterval; }
});
Object.defineProperty(exports, 'useLatestRef', {
	enumerable: true,
	get: function () { return react.useLatestRef; }
});
Object.defineProperty(exports, 'useMediaQuery', {
	enumerable: true,
	get: function () { return react.useMediaQuery; }
});
Object.defineProperty(exports, 'useMenu', {
	enumerable: true,
	get: function () { return react.useMenu; }
});
Object.defineProperty(exports, 'useMenuButton', {
	enumerable: true,
	get: function () { return react.useMenuButton; }
});
Object.defineProperty(exports, 'useMenuContext', {
	enumerable: true,
	get: function () { return react.useMenuContext; }
});
Object.defineProperty(exports, 'useMenuDescendant', {
	enumerable: true,
	get: function () { return react.useMenuDescendant; }
});
Object.defineProperty(exports, 'useMenuDescendants', {
	enumerable: true,
	get: function () { return react.useMenuDescendants; }
});
Object.defineProperty(exports, 'useMenuDescendantsContext', {
	enumerable: true,
	get: function () { return react.useMenuDescendantsContext; }
});
Object.defineProperty(exports, 'useMenuItem', {
	enumerable: true,
	get: function () { return react.useMenuItem; }
});
Object.defineProperty(exports, 'useMenuList', {
	enumerable: true,
	get: function () { return react.useMenuList; }
});
Object.defineProperty(exports, 'useMenuOption', {
	enumerable: true,
	get: function () { return react.useMenuOption; }
});
Object.defineProperty(exports, 'useMenuOptionGroup', {
	enumerable: true,
	get: function () { return react.useMenuOptionGroup; }
});
Object.defineProperty(exports, 'useMenuPositioner', {
	enumerable: true,
	get: function () { return react.useMenuPositioner; }
});
Object.defineProperty(exports, 'useMenuState', {
	enumerable: true,
	get: function () { return react.useMenuState; }
});
Object.defineProperty(exports, 'useMergeRefs', {
	enumerable: true,
	get: function () { return react.useMergeRefs; }
});
Object.defineProperty(exports, 'useModal', {
	enumerable: true,
	get: function () { return react.useModal; }
});
Object.defineProperty(exports, 'useModalContext', {
	enumerable: true,
	get: function () { return react.useModalContext; }
});
Object.defineProperty(exports, 'useOptionalPart', {
	enumerable: true,
	get: function () { return react.useOptionalPart; }
});
Object.defineProperty(exports, 'useOutsideClick', {
	enumerable: true,
	get: function () { return react.useOutsideClick; }
});
Object.defineProperty(exports, 'usePanGesture', {
	enumerable: true,
	get: function () { return react.usePanGesture; }
});
Object.defineProperty(exports, 'usePointerEvent', {
	enumerable: true,
	get: function () { return react.usePointerEvent; }
});
Object.defineProperty(exports, 'usePopover', {
	enumerable: true,
	get: function () { return react.usePopover; }
});
Object.defineProperty(exports, 'usePopoverContext', {
	enumerable: true,
	get: function () { return react.usePopoverContext; }
});
Object.defineProperty(exports, 'usePortalManager', {
	enumerable: true,
	get: function () { return react.usePortalManager; }
});
Object.defineProperty(exports, 'usePrefersReducedMotion', {
	enumerable: true,
	get: function () { return react.usePrefersReducedMotion; }
});
Object.defineProperty(exports, 'usePrevious', {
	enumerable: true,
	get: function () { return react.usePrevious; }
});
Object.defineProperty(exports, 'useQuery', {
	enumerable: true,
	get: function () { return react.useQuery; }
});
Object.defineProperty(exports, 'useRadio', {
	enumerable: true,
	get: function () { return react.useRadio; }
});
Object.defineProperty(exports, 'useRadioGroup', {
	enumerable: true,
	get: function () { return react.useRadioGroup; }
});
Object.defineProperty(exports, 'useRadioGroupContext', {
	enumerable: true,
	get: function () { return react.useRadioGroupContext; }
});
Object.defineProperty(exports, 'useRangeSlider', {
	enumerable: true,
	get: function () { return react.useRangeSlider; }
});
Object.defineProperty(exports, 'useRangeSliderContext', {
	enumerable: true,
	get: function () { return react.useRangeSliderContext; }
});
Object.defineProperty(exports, 'useSafeLayoutEffect', {
	enumerable: true,
	get: function () { return react.useSafeLayoutEffect; }
});
Object.defineProperty(exports, 'useShortcut', {
	enumerable: true,
	get: function () { return react.useShortcut; }
});
Object.defineProperty(exports, 'useSlider', {
	enumerable: true,
	get: function () { return react.useSlider; }
});
Object.defineProperty(exports, 'useSliderContext', {
	enumerable: true,
	get: function () { return react.useSliderContext; }
});
Object.defineProperty(exports, 'useTimeout', {
	enumerable: true,
	get: function () { return react.useTimeout; }
});
Object.defineProperty(exports, 'useTooltip', {
	enumerable: true,
	get: function () { return react.useTooltip; }
});
Object.defineProperty(exports, 'useUnmountEffect', {
	enumerable: true,
	get: function () { return react.useUnmountEffect; }
});
Object.defineProperty(exports, 'useUpdateEffect', {
	enumerable: true,
	get: function () { return react.useUpdateEffect; }
});
Object.defineProperty(exports, 'useWhyDidYouUpdate', {
	enumerable: true,
	get: function () { return react.useWhyDidYouUpdate; }
});
Object.defineProperty(exports, 'visuallyHiddenStyle', {
	enumerable: true,
	get: function () { return react.visuallyHiddenStyle; }
});
exports.Card = Card;
exports.CardBody = CardBody;
exports.CardFooter = CardFooter;
exports.CardHeader = CardHeader;
exports.Checkbox = Checkbox;
exports.Pagination = Pagination;
exports.Step = Step;
exports.Steps = Steps;
exports.Toast = Toast;
exports.usePagination = usePagination;
exports.useSteps = useSteps;
exports.useToast = useToast;
